import { Table } from 'antd'
import { search } from 'jmespath'
import type { JsonData } from 'react-toolkits'
import { useToolkitsStore } from 'react-toolkits'
import { STRING_VAR_REG } from '../constants'
import { tableSchema } from '../schemas/table'
import { useDataStore } from '../stores'
import { renderSchemaArray } from '../utils'
import { withParsedData } from './base'

export const TableRenderer = withParsedData(tableSchema)<{ source?: object }>(({ parsedData, source }) => {
  const { columns, footer, rowKey, data, api, storeIdRef, ...rest } = parsedData
  const { dataMap } = useDataStore()
  const { axios } = useToolkitsStore(s => s)

  let dataSource = []

  if (api) {
    let storeData = null

    if (storeIdRef) {
      storeData = dataMap.get(storeIdRef)
    }

    const newUrl = api.replace(/\$\{([^}]+)\}/g, (_match, key) => search(storeData, key) ?? '')
    axios.get<JsonData>(newUrl).then(res => {
      dataSource = res.data.data
    })
  } else {
    if (Array.isArray(data)) {
      dataSource = data
    } else {
      // 将字符串变量转换为 JMESPath 查询
      const match = data?.match(STRING_VAR_REG)
      if (match) {
        const result = search(source, match[1])
        dataSource = result ?? []
      }
    }
  }

  const renderFooter = footer && (() => renderSchemaArray(footer))

  return <Table {...rest} rowKey={rowKey} columns={columns} footer={renderFooter} dataSource={dataSource} />
})
